<template>
    <!-- TW Snippet Start v2.0+ -->
    <div class="bg-white" :id="$props.id">
        <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8 lg:grid lg:grid-cols-3 lg:gap-x-8">
            <div>
                <h2 class="text-base font-semibold text-indigo-600 uppercase tracking-wide">Vše co potřebujete</h2>
                <p class="mt-2 text-3xl font-extrabold text-gray-900">na jednom místě</p>
                <p class="mt-4 text-lg text-gray-500">Jsou pro Vás datové zprávy denním chlebem? Využijte naše bezkonkurenční služby!</p>
            </div>
            <div class="mt-12 lg:mt-0 lg:col-span-2">
                <dl class="space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:grid-rows-4 sm:grid-flow-col sm:gap-x-6 sm:gap-y-10 lg:gap-x-8">
                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Bezpečné cloudové úložiště
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Vaše data jsou v bezpečí v profesionálních datacentrech.
                            </dd>
                        </div>
                    </div>

                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Příjemné chytré prostředí
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Uživatelské prostředí je jednoduché, moderní a intuitivní.
                            </dd>
                        </div>
                    </div>

                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Rychlé vyhledávání
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Hledání a filtrování zpráv nikdy nebylo jednodušší.
                            </dd>
                        </div>
                    </div>

                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Možnost nedoručení při přihlášení
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Podívejte se na své staré zprávy bez nutnosti doručení nových.
                            </dd>
                        </div>
                    </div>

                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Profesionální podpora
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Emailem nebo po telefonu? Rádi Vám kdykoli poradíme.
                            </dd>
                        </div>
                    </div>

                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Snadný přechod
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Automatický import z jiného klienta na datové zprávy je hračka!
                            </dd>
                        </div>
                    </div>

                    <!--
                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Stažení všech zpráv v archivu.
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Jednoduše si stáhněte archiv všech vašich dat.
                            </dd>
                        </div>
                    </div>
                    -->

                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Dlouhodobé úložiště zdarma
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Starší zprávy Vám rádi uložíme zdarma na pomalejším úložišti.
                            </dd>
                        </div>
                    </div>

                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Responzivní design
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Počítač, telefon nebo tablet? Všude jsme jako doma!
                            </dd>
                        </div>
                    </div>
                    <!--
                    <div class="flex">
                        <svg class="shrink-0 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class="ml-3">
                            <dt class="text-lg leading-6 font-medium text-gray-900">
                                Deployment na vlastní hosting
                            </dt>
                            <dd class="mt-2 text-base text-gray-500">
                                Chcete neomezenou DSchránku provozovat na vlastním serveru? I to je možnost. Napište nám a rádi se na všem domluvíme!
                            </dd>
                        </div>
                    </div>
                    -->
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Features"
}
</script>

<style scoped>

</style>
